module.exports = {"terms-conditions":"terms and conditions","contact":"Contact","legal-notice":"Legal notice","faqs":"Frequently asked questions","cookies-policy":"Cookies policy","privacy-policy":"Privacy Policy","sgsi-policy":"SGSI Policy","login":{"iam-professional":"I'm a professional"}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/public/footer-360.json
// module id = 540
// module chunks = 116